export default function formatMobileNumber(number) {
    // Remove any existing spaces and non-numeric characters
    number = number?.replace(/\D/g, '');
  
    // Insert a space every 4 digits using a regular expression
    number = number?.replace(/(\d{4})/g, '$1 ');
  
    // Remove any trailing space
    number = number?.trim();
  
    return number;
}